<template>
    <div class="my-wrapper">
        <div class="suggested">
            <div class="header">
                <span id="title">{{ $t("suggested_blogs.blog_title") }}</span>
            </div>
            <div class="blogs">
                <div @click="$router.push($store.getters.getLocaleLink('/blog/dizi-ile-ingilizce-ogrenmek-ayrintili-rehber'))"
                    class="blog">
                    <span class="right"> {{ $t("suggested_blogs.blog1") }}
                    </span>
                    <div class="left">
                        <img src="@/assets/account/go-list.svg" alt="" width="18">
                    </div>
                </div>
                <div @click="$router.push($store.getters.getLocaleLink('/blog/ingilizceyi-dizilerden-ogrenmek-isteyenler-icin-en-kolay-8-dizi'))"
                    class="blog">
                    <span class="right"> {{ $t("suggested_blogs.blog2") }}
                    </span>
                    <div class="left">
                        <img src="@/assets/account/go-list.svg" alt="" width="18">
                    </div>
                </div>
                <div @click="$router.push($store.getters.getLocaleLink('/blog/ingilizce-dizi-ve-filmlerde-en-sik-kullanilan-5000-kelime'))"
                    class="blog">
                    <span class="right"> {{ $t("suggested_blogs.blog3") }}
                    </span>
                    <div class="left">
                        <img src="@/assets/account/go-list.svg" alt="" width="18">
                    </div>
                </div>
                <div @click="$router.push($store.getters.getLocaleLink('/blog/a1-seviye-ingilizce-kelimeler-ve-anlamlari'))"
                    class="blog">
                    <span class="right"> {{ $t("suggested_blogs.blog4") }}
                    </span>
                    <div class="left">
                        <img src="@/assets/account/go-list.svg" alt="" width="18">
                    </div>
                </div>
                <div @click="$router.push($store.getters.getLocaleLink('/blog/yds-yokdil-sinavlarinda-en-cok-cikmis-600-kelime-listesi'))"
                    class="blog">
                    <span class="right"> {{ $t("suggested_blogs.blog5") }}
                    </span>
                    <div class="left">
                        <img src="@/assets/account/go-list.svg" alt="" width="18">
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
</script>
<style scoped>
.my-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin: 48px 0px;
    padding: 0;
}

.suggested {
    display: flex;
    flex-direction: column;
    padding: 16px;
    gap: 32px;
    border-radius: 16px;
    background: var(--Lightest-Gray, #FBFBFB);
    box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.25);
    width: 100%;
    max-width: 920px;
    padding: 24px 48px 24px 48px;
}

.suggested .header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.suggested .header #title {
    color: var(--Black-Gray, #696969);
    font-family: Poppins;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}

.suggested .blogs {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.suggested .blogs .blog {
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-radius: 8px;
    background: var(--Lightest-Gray, #FBFBFB);
    box-shadow: 0px 4px 4px 0px #D9D9D9;
    padding: 16px 24px;
    transition: background 0.8s;
}

.suggested .blogs .blog:hover {
    background: var(--Light-Tertiary, #FFFAEB);
}

.suggested .blogs .blog .right {
    color: var(--Primary, #8887C6);
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

@media (max-width: 700px) {
    .suggested {
        padding: 16px 24px 16px 24px;
    }


    .suggested .header #title,
    .suggested .blogs .blog .right {
        font-size: 14px;
        font-weight: 700;
    }

}
</style>